export default __webpack_public_path__ + "static/media/Info.c713f112.svg";